import type { IPlatformAdapter } from '../ports/IPlatformAdapter'
import type {
  BackButtonOptions,
  HapticStyle,
  MainButtonOptions,
  PlatformLaunchPayload,
  PlatformTheme,
} from '../ports/types'
import { openExternalUrl } from '../openExternalUrl'

const DEFAULT_THEME: PlatformTheme = {
  colorScheme: 'light',
}

/**
 * Production / browser default: no platform host.
 * All chrome APIs are no-ops; `init` returns an empty payload.
 */
export class NoopPlatformAdapter implements IPlatformAdapter {
  readonly kind = 'none' as const

  async init(): Promise<PlatformLaunchPayload> {
    return {
      kind: this.kind,
      raw: null,
      startParam: null,
    }
  }

  getTheme(): PlatformTheme {
    return { ...DEFAULT_THEME }
  }

  setMainButton(_options: MainButtonOptions | null): void {}

  setBackButton(_options: BackButtonOptions | null): void {}

  haptic(_style?: HapticStyle): void {}

  close(): void {}

  openLink(url: string): void {
    openExternalUrl(url)
  }

  async requestContact(): Promise<string | null> {
    return null
  }

  getStartParam(): string | null {
    return null
  }
}
